import { t } from 'i18next'

import { DeliveryHourType as DeliveryHourTypeBFF } from '@enechain/eposition-proto/bfftypes/v1/deal_pb'
// FIXME: 本来BFFの型を使うべき。フロントの変換でしか使ってないので現状問題ないが、PR分けて修正する
import { DeliveryHourType } from '@enechain/eposition-proto/types/v1/deal_pb'

export function convertDeliveryHourTypeLabel(value: DeliveryHourType): string {
  switch (value) {
    case DeliveryHourType.BASE:
      return t('domain:shared.delivery_hour_type.base')
    case DeliveryHourType.PEAK:
      return t('domain:shared.delivery_hour_type.peak')
    default:
      return t('domain:shared.delivery_hour_type.unspecified')
  }
}

export function convertDeliveryHourTypeLabelLong(
  value: DeliveryHourTypeBFF,
): string {
  switch (value) {
    case DeliveryHourTypeBFF.BASE:
      return t('domain:shared.delivery_hour_type.base_long')
    case DeliveryHourTypeBFF.MIDDLE:
      return t('domain:shared.delivery_hour_type.peak_long')
    default:
      return t('domain:shared.delivery_hour_type.unspecified')
  }
}
